const transitionDuration = 'webkitTransition' in document.head.style ? 'webkitTransitionDuration' : 'transitionDuration';
export default transitionDuration;



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/strings/transitionDuration.js
// module id = 25
// module chunks = 0